// extracted by mini-css-extract-plugin
module.exports = {"container":"e_hH","readReviewButton":"e_iH","arrowRight":"e_jH","imageContainer":"e_kH","image":"e_lH","badge":"e_mH","badgeImage":"e_nH","content":"e_oH","title":"e_pH"};